const OPTIONS_PAUSED_BIT = 0
const OPTIONS_ALLOW_CREATOR_ROYALTY_BIT = 1
const OPTIONS_ALLOW_SHAREHOLDERS_MASK = 4
const OPTIONS_FLAGS_SHIFT = 3
const OPTIONS_PURCHASE_FEE_SHIFT = OPTIONS_FLAGS_SHIFT + 10
const OPTIONS_PURCHASE_FEE_MASK = 0x3ff
const OPTIONS_MINT_FEE_SHIFT = OPTIONS_PURCHASE_FEE_SHIFT + 10
const OPTIONS_MINT_FEE_MASK = 0xfffff
const OPTIONS_TRANSACTION_FEE_SHIFT = OPTIONS_MINT_FEE_SHIFT + 20
const OPTIONS_TRANSACTION_FEE_MASK = 0xfffff
const OPTIONS_MAX_PARTNERS_SHIFT = OPTIONS_TRANSACTION_FEE_SHIFT + 20
const OPTIONS_MAX_PARTNERS_MASK = 0xfffff
const OPTIONS_MAX_NUM_TERMS_SHIFT =
  OPTIONS_MAX_PARTNERS_SHIFT + 20
const OPTIONS_MAX_NUM_TERMS_MASK = 0xFFFFF
const OPTIONS_MAX_SHARES_OFFERED_SHIFT =
  OPTIONS_MAX_NUM_TERMS_SHIFT + 20
const OPTIONS_MAX_SHARES_OFFERED_MASK = 0xFFFFF
const OPTIONS_MAX_SHARE_PERCENT_SHIFT =
  OPTIONS_MAX_SHARES_OFFERED_SHIFT + 20
const OPTIONS_MAX_SHARE_PERCENT_MASK = 0x3FF

const PRICE_MASK = 'ffffffffffffffff'

const TOKEN_TYPE_SHIFT = 64 //Price is 64 bits
const TOKEN_TYPE_MASK = 0xff //0-255 token types
/** Predefined album token type is ORed into price when mintAlbum is called. */
const TOKEN_TYPE_ALBUM = 0x01

const PLATFORM_SHIFT = TOKEN_TYPE_SHIFT + 8
const PLATFORM_MASK = 0xff //0-255 platforms
const TOKEN_PLATFORM = {
  PICTURE: 0x0,
  MUSIC: 1,
  TRAIL: 2,
  PLACE: 3,
  VORTEX: 4
}
const PRIVILEGES_SHIFT = PLATFORM_SHIFT + 8
const PRIVILEGES_MASK = 0x01
const TOKEN_HAS_PRIVILEGES = 1
const ROYALTY_MASK = 0x3ff
const ROYALTY_DIVISOR = 1000

const OFFERING_STATE_MASK = 0x03

const OFFERING_STATE_OPEN = 1
const OFFERING_STATE_CLOSED = 2
const OFFERING_STATE_PAID = 3
const NUM_PARTNERS_MASK = 0xfffff
const NUM_PARTNERS_SHIFT = 2
const MIN_TOKEN_SALE_PRICE_MASK = 'ffffffffffffffff'
const MIN_TOKEN_SALE_PRICE_SHIFT = NUM_PARTNERS_SHIFT + 20
const SHARE_PRICE_MASK = 'ffffffffffffffff'
const SHARE_PRICE_SHIFT = MIN_TOKEN_SALE_PRICE_SHIFT + 64
const SHARES_OFFERED_MASK = 0xfffff
const SHARES_OFFERED_SHIFT = SHARE_PRICE_SHIFT + 64
const SHARE_PERCENT_MASK = 0xfffff
const SHARE_PERCENT_CLEAR_MASK = '3FFFFFFFFFFFFFFFFFFFFFFFFFF'
const SHARE_PERCENT_SHIFT = SHARES_OFFERED_SHIFT + 20

const TOTAL_SHARE_PERCENT_MASK = 0x3ff
const TOTAL_SHARE_PERCENT_SHIFT = SHARE_PERCENT_SHIFT

const TOTAL_SHARE_PERCENT_MIN = 10000 //Minimum percent offered 1% 4 implied decimal places
const SHARE_PERCENT_DIVISOR = TOTAL_SHARE_PERCENT_MIN * 100

const PARTNER_NUM_SHARES_MASK = 0xfffff
const PARTNER_CLEAR_NUM_SHARES_MASK = 'ffffffffff00000'
const PARTNER_SHARES_OFFERED_MASK = 0xfffff
const PARTNER_SHARES_OFFERED_SHIFT = 20
const PARTNER_CLEAR_SHARES_OFFERED_MASK = 'fffff00000fffff'
const PARTNER_SHARE_PRICE_MASK = 'ffffffffffffffff'
const PARTNER_SHARE_PRICE_SHIFT = PARTNER_SHARES_OFFERED_SHIFT + 20

module.exports = {
  OPTIONS_PAUSED_BIT,
  OPTIONS_ALLOW_CREATOR_ROYALTY_BIT,
  OPTIONS_FLAGS_SHIFT,
  OPTIONS_PURCHASE_FEE_SHIFT,
  OPTIONS_PURCHASE_FEE_MASK,
  OPTIONS_MINT_FEE_SHIFT,
  OPTIONS_MINT_FEE_MASK,
  OPTIONS_TRANSACTION_FEE_SHIFT,
  OPTIONS_TRANSACTION_FEE_MASK,
  OPTIONS_MAX_PARTNERS_SHIFT,
  OPTIONS_MAX_PARTNERS_MASK,
  OPTIONS_MAX_SHARES_OFFERED_SHIFT,
  OPTIONS_MAX_SHARES_OFFERED_MASK,
  OPTIONS_MAX_SHARE_PERCENT_SHIFT,
  OPTIONS_MAX_SHARE_PERCENT_MASK,
  PRICE_MASK,

  OFFERING_STATE_MASK,

  OFFERING_STATE_OPEN,
  OFFERING_STATE_CLOSED,
  OFFERING_STATE_PAID,
  NUM_PARTNERS_MASK,
  NUM_PARTNERS_SHIFT,
  MIN_TOKEN_SALE_PRICE_MASK,
  MIN_TOKEN_SALE_PRICE_SHIFT,
  SHARE_PRICE_MASK,
  SHARE_PRICE_SHIFT,
  SHARES_OFFERED_MASK,
  SHARES_OFFERED_SHIFT,
  SHARE_PERCENT_DIVISOR,
  SHARE_PERCENT_MASK,
  SHARE_PERCENT_CLEAR_MASK,
  SHARE_PERCENT_SHIFT,
  TOTAL_SHARE_PERCENT_MIN,
  TOTAL_SHARE_PERCENT_MASK,
  TOTAL_SHARE_PERCENT_SHIFT,

  PARTNER_NUM_SHARES_MASK,
  PARTNER_CLEAR_NUM_SHARES_MASK,
  PARTNER_SHARES_OFFERED_MASK,
  PARTNER_SHARES_OFFERED_SHIFT,
  PARTNER_CLEAR_SHARES_OFFERED_MASK,
  PARTNER_SHARE_PRICE_MASK,
  PARTNER_SHARE_PRICE_SHIFT,

  PLATFORM_SHIFT,
  PLATFORM_MASK,
  TOKEN_PLATFORM,
  PRIVILEGES_SHIFT,
  PRIVILEGES_MASK,
  TOKEN_HAS_PRIVILEGES,
  TOKEN_TYPE_ALBUM,
  TOKEN_TYPE_SHIFT,
  TOKEN_TYPE_MASK,

  ROYALTY_DIVISOR,
  ROYALTY_MASK,
}
